<div style="text-align: center">
  <h2>Waiting for authorization…</h2>
  <p>{{ authCode }}</p>
</div>
